"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js");

var _react = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _config = require("./config");

var _lunaTooltip = _interopRequireDefault(require("../luna-tooltip"));

var _lunaIcon = _interopRequireWildcard(require("../luna-icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var LunaFormControlGroup = _react["default"].forwardRef(function (props, ref) {
  var className = props.className,
      systemContext = props.systemContext,
      label = props.label,
      optional = props.optional,
      utilityArea = props.utilityArea,
      helpMessage = props.helpMessage,
      systemMessage = props.systemMessage,
      isValid = props.isValid,
      validate = props.validate,
      onValidate = props.onValidate,
      disabled = props.disabled,
      onChange = props.onChange,
      onClick = props.onClick,
      onKeyDown = props.onKeyDown,
      onKeyUp = props.onKeyUp,
      onMouseDown = props.onMouseDown,
      onMouseEnter = props.onMouseEnter,
      onMouseLeave = props.onMouseLeave,
      onMouseUp = props.onMouseUp,
      onTouchEnd = props.onTouchEnd,
      onTouchMove = props.onTouchMove,
      onTouchStart = props.onTouchStart;
  var eventProps = {
    onChange: onChange,
    onClick: onClick,
    onKeyDown: onKeyDown,
    onKeyUp: onKeyUp,
    onMouseDown: onMouseDown,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    onMouseUp: onMouseUp,
    onTouchEnd: onTouchEnd,
    onTouchMove: onTouchMove,
    onTouchStart: onTouchStart
  };
  var isControlled = typeof isValid === 'boolean';

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isValidating = _useState2[0],
      setIsValidating = _useState2[1];

  var _useState3 = (0, _react.useState)(true),
      _useState4 = _slicedToArray(_useState3, 2),
      uncontrolledIsValid = _useState4[0],
      setUncontrolledIsValid = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = _slicedToArray(_useState5, 2),
      childValue = _useState6[0],
      setChildValue = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = _slicedToArray(_useState7, 2),
      childAssertsInvalid = _useState8[0],
      setChildAssertsInvalid = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = _slicedToArray(_useState9, 2),
      internalSystemMessge = _useState10[0],
      setInternalSystemMessge = _useState10[1];

  var calculatedIsValid = isControlled ? isValid : uncontrolledIsValid;

  if (systemContext !== _config.FormControlGroupStates.valid && !systemMessage) {
    throw new Error('LunaFormControlGroup: systemMessage required when isValid is false');
  }

  if (isControlled && validate) {
    throw new Error('LunaFormControlGroup: element cannot do self validation as a controlled element. Provide either isValid or validate');
  }

  var getWrapperClass = function getWrapperClass() {
    var _classnames;

    return (0, _classnames2["default"])(_config.classes.wrapper.base, (_classnames = {}, _defineProperty(_classnames, _config.classes.wrapper.isInvalid, !calculatedIsValid || isValidating && childAssertsInvalid), _defineProperty(_classnames, _config.classes.wrapper.isDisabled, disabled), _defineProperty(_classnames, _config.classes.wrapper.isOmitted, systemContext === _config.FormControlGroupStates.omitted && calculatedIsValid), _defineProperty(_classnames, _config.classes.wrapper.isAssumed, systemContext === _config.FormControlGroupStates.assumed && calculatedIsValid), _classnames), className);
  };

  var getLabelUtility = function getLabelUtility() {
    if (!utilityArea) {
      return null;
    }

    if (_react["default"].isValidElement(utilityArea)) {
      return utilityArea;
    }

    var iconConfig = {
      size: _lunaIcon.LunaIconSizes.s10,
      color: _lunaIcon.LunaIconColors.ultramarine90
    };

    if (typeof utilityArea === 'string') {
      return _react["default"].createElement(_lunaTooltip["default"], {
        content: utilityArea,
        showOnHover: true
      }, _react["default"].createElement(_lunaIcon["default"], _extends({
        glyph: "help"
      }, iconConfig)));
    }

    return _react["default"].createElement(_lunaTooltip["default"], {
      content: utilityArea.content,
      showOnHover: true
    }, _react["default"].createElement(_lunaIcon["default"], _extends({
      glyph: utilityArea.glyph
    }, iconConfig)));
  };

  var getSystemGlyph = function getSystemGlyph() {
    if (calculatedIsValid && !systemContext) {
      return null;
    }

    if (!calculatedIsValid || childAssertsInvalid) {
      return 'warning-filled';
    }

    switch (systemContext) {
      case _config.FormControlGroupStates.omitted:
        return 'flag-filled';

      case _config.FormControlGroupStates.assumed:
        return 'thunderbolt-filled';

      default:
        if (systemContext) {
          throw new Error("LunaFormControlGroup: systemContext should be passed in as one of the FormControlGroupStates instead of: ".concat(systemContext, "."));
        }

        throw new Error('LunaFormControlGroup: when input is deemed valid and a systemMessage is included, systemContext is required and should be passed in.');
    }
  };

  var handleValidate = function handleValidate(value) {
    var foundValid;

    if (childAssertsInvalid) {
      foundValid = childAssertsInvalid;
      setUncontrolledIsValid(foundValid);
    } else if (isControlled) {
      foundValid = isValid;
    } else {
      if (!optional && _lodash["default"].isEmpty(value)) {
        foundValid = false;
        setInternalSystemMessge('This field is required, please provide a value');
      } else {
        if (validate) {
          foundValid = validate(value);
        } else {
          foundValid = true;
        }
      }

      setUncontrolledIsValid(foundValid);
      foundValid && setInternalSystemMessge(null);
    }

    _lodash["default"].isFunction(onValidate) && onValidate(foundValid);
  };

  var handleBlur = function handleBlur(childHandleBlur) {
    return function (event) {
      _lodash["default"].isFunction(childHandleBlur) && childHandleBlur(event);
      var value = event.constructor.name === 'SyntheticEvent' ? event.target.value : event;

      if (!isValidating) {
        setIsValidating(true);
        setChildValue(value);
        handleValidate(value);
      }

      if (isValidating) {
        handleValidate(childValue);
      }
    };
  };

  var handleChange = function handleChange(childHandleChange) {
    return function (event) {
      if (childHandleChange) {
        childHandleChange(event);
      }

      var value = event.constructor.name === 'SyntheticEvent' ? event.target.value : event;
      setChildValue(value);

      if (isValidating) {
        handleValidate(value);
      }
    };
  };

  var handleChildValidate = function handleChildValidate(assertsValid, message, value) {
    if (assertsValid) {
      setChildAssertsInvalid(false);

      if (isValidating && !optional && !_lodash["default"].isEmpty(value)) {
        handleValidate(value);
      }
    } else {
      setChildAssertsInvalid(message);
      handleValidate(value);
    }
  };

  var getChildElement = function getChildElement() {
    var child = _react["default"].Children.only(props.children);

    if (child.props.onValidate || typeof child.props.isValid === 'boolean' || child.props.validate) {
      throw new Error('LunaFormControlGroup: child element is not allowed to have validation props (onValidate, isValid, or validate).  Put validation props on the LunaFormControlGroup');
    }

    return _react["default"].cloneElement(child, {
      onBlur: handleBlur(child.props.onBlur),
      onChange: handleChange(child.props.onChange),
      __onValidate: handleChildValidate,
      disabled: disabled
    });
  };

  var _systemMessage = !calculatedIsValid || systemContext ? childAssertsInvalid || internalSystemMessge || systemMessage : null;

  var child = getChildElement();
  var requireID = ['LunaSearch', 'LunaInput', 'LunaDatepicker', 'LunaSelect'];

  if (requireID.includes(child.type.displayName) && !child.props.id) {
    console.warn("LunaFormControlGroup: ".concat(child.type.displayName, " requires an ID prop to be linked to label. Please add ID prop to ").concat(child.type.displayName));
  }

  return _react["default"].createElement("div", _extends({
    ref: ref,
    className: getWrapperClass()
  }, eventProps), _react["default"].createElement("label", {
    htmlFor: child.props.id,
    className: _config.classes.label.base
  }, _react["default"].createElement("span", {
    className: _config.classes.label.message
  }, "".concat(label, "\t"), optional && _react["default"].createElement("span", {
    className: _config.classes.label.optionality
  }, "Optional")), _react["default"].createElement("span", {
    className: _config.classes.label.utility
  }, getLabelUtility())), _react["default"].createElement("div", {
    className: _config.classes.input.base
  }, child), _react["default"].createElement("div", {
    className: _config.classes.context.wrapper
  }, helpMessage && _react["default"].createElement("span", {
    className: _config.classes.context.helpMessage
  }, helpMessage), _systemMessage && _react["default"].createElement("span", {
    className: _config.classes.context.systemMessage
  }, _react["default"].createElement(_lunaIcon["default"], {
    glyph: getSystemGlyph()
  }), "\t".concat(_systemMessage))));
});

LunaFormControlGroup.displayName = 'LunaFormControlGroup';
LunaFormControlGroup.defaultProps = {};
LunaFormControlGroup.propTypes = {
  className: _propTypes["default"].string,
  children: _propTypes["default"].element.isRequired,
  disabled: _propTypes["default"].bool,
  helpMessage: _propTypes["default"].string,
  isValid: _propTypes["default"].bool,
  label: _propTypes["default"].string,
  onValidate: _propTypes["default"].func,
  optional: _propTypes["default"].bool,
  systemContext: _propTypes["default"].oneOf(Object.values(_config.FormControlGroupStates)),
  systemMessage: _propTypes["default"].string,
  utilityArea: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].shape({
    content: _propTypes["default"].string,
    glyph: _propTypes["default"].string
  }), _propTypes["default"].element]),
  validate: _propTypes["default"].func,
  onChange: _propTypes["default"].func,
  onClick: _propTypes["default"].func,
  onKeyDown: _propTypes["default"].func,
  onKeyUp: _propTypes["default"].func,
  onMouseDown: _propTypes["default"].func,
  onMouseEnter: _propTypes["default"].func,
  onMouseLeave: _propTypes["default"].func,
  onMouseUp: _propTypes["default"].func,
  onTouchEnd: _propTypes["default"].func,
  onTouchMove: _propTypes["default"].func,
  onTouchStart: _propTypes["default"].func
};
var _default = LunaFormControlGroup;
exports["default"] = _default;
